<template>
  <div class="cs-question">
    <ai-block-tips :message="errorMessage">
      <template v-if="questionType === GLOBAL.enumQuestionnaireQuestionType.Choice">
        <ai-choice :index="index" :multiple="isMultiple" :max="maxValue" :title-content="title" :titleSuffixText="titleSuffixText" :options="optionsData"
          v-model="modelValue" />
      </template>

      <template v-if="questionType === GLOBAL.enumQuestionnaireQuestionType.ShortAnswer">
        <ai-short-answer :index="index" :title-content="title" v-model="modelValue" />
      </template>

      <template v-if="questionType === GLOBAL.enumQuestionnaireQuestionType.Rate">
        <ai-rate :highlightSingleScore="true" :index="index" :min="minValue" :max="maxValue" :title-content="title" :options="optionsData"
          v-model="modelValue" />
      </template>

      <span v-if="!!annotation" class="cs-question-annotation">{{annotation}}</span>
    </ai-block-tips>
  </div>
</template>

<script>
import _global from "@/core/global";

export default {
  name: "csQuestion",
  props: {
    questionType: {
      type: Number,
      required: true,
      validator: (value) =>
        _global.enumQuestionnaireQuestionType
          .getOptions()
          .map((op) => op.value)
          .contains(value),
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    isCustomized: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    annotation: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    errorMessage: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Boolean, Number, Array],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "valueChange",
  },
  computed: {
    titleSuffixText() {
      return this.isMultiple ? "(多选)" : "(单选)";
    },
    minValue() {
      return `${this.min}`.toNumber();
    },
    maxValue() {
      return `${this.max}`.toNumber();
    },
    optionsData() {
      if (
        this.questionType === this.GLOBAL.enumQuestionnaireQuestionType.Rate &&
        !this.isCustomized
      )
        return [];

      return this.options;
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("valueChange", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-question {
  .ai-block-tips {
    margin-bottom: 10px;
  }

  .ai-choice {
    /deep/ .ai-choice__list__item {
      &.is-active {
        background-color: var(--choice-bg-color-active, #409eff);
        color: #fff;
      }
    }
  }

  .ai-rate {
    /deep/ .ai-rate__content {
      .ai-rate__content__item {
        border-style: none;

        &.is-hover-active {
          background-color: var(--choice-bg-color-active, rgba(#409eff, 0.65));
          color: #fff;
        }

        &.is-active {
          background-color: var(--choice-bg-color-active, #409eff);
          color: #fff;
        }
      }
    }
  }

  .cs-question-annotation {
    margin-left: 25px;
    font-style: italic;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>


// WEBPACK FOOTER //
// src/core/questionnaire-ui/components/csQuestion.vue